export default __webpack_public_path__ + "static/media/DSC_0534.1f63f60d.jpg";